import {
  FETCH_ALL_CATEGORIES_SUCCESS,
  FETCH_INVENTORY_CATEGORIES_REQUEST,
  FETCH_INVENTORY_CATEGORIES_SUCCESS,
  FETCH_INVENTORY_CATEGORIES_FAILURE,
  FETCH_SF_CATEGORIES_REQUEST,
  FETCH_SF_CATEGORIES_SUCCESS,
  FETCH_SF_CATEGORIES_FAILURE
} from "Constants/redux/CategoryListConstants";

const INITIAL_STATE = {
  categories: [
    { id: 1, name: "Chairs" },
    { id: 2, name: "Tables" },
    { id: 3, name: "Special Seating" },
    { id: 4, name: "Lighting" }
  ],
  itemCategories: [],
  inventoryCategoryGroups: [],
  sfCategories: [],
  loading: false
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case FETCH_ALL_CATEGORIES_SUCCESS:
      return { ...state, categories: action.response.data.categories };

    case FETCH_INVENTORY_CATEGORIES_REQUEST:
    case FETCH_SF_CATEGORIES_REQUEST:
      return { ...state, loading: true };
    case FETCH_INVENTORY_CATEGORIES_FAILURE:
    case FETCH_SF_CATEGORIES_FAILURE:
      return { ...state, loading: false };
    case FETCH_INVENTORY_CATEGORIES_SUCCESS:
      return {
        ...state,
        [`${action.productType}Categories`]: action.response.data,
        loading: false
      };
    case FETCH_SF_CATEGORIES_SUCCESS:
      return {
        ...state,
        sfCategories: action.response.data.sfCategories,
        loading: false
      };
    default:
      return state;
  }
};
